import { Popover, theme } from '@acorns/web-components'
import { motion } from 'framer-motion'
import styled from 'styled-components'

import { fonts } from '../../../../styles'

type GraphSliderProps = {
  barWidth: number
  height: number
}

export const GraphSlider = styled(motion.div)<GraphSliderProps>`
  height: ${(props) => `${props.height}px`};
  left: 0;
  position: absolute;
  text-align: center;
  width: ${(props) => props.barWidth}px;
  z-index: 3;
`

export const SliderBar = styled(motion.div)<{ barWidth: number }>`
  background-color: ${theme.colors.white};
  border-radius: 5px;
  bottom: 0;
  width: ${(props) => props.barWidth}px;
`

type StyledPopoverType = {
  length: number
  shiftLeft: boolean
}

export const StyledPopover = styled(Popover)<StyledPopoverType>`
  ${fonts.AN_12_500_16}
  border: none;
  color: ${theme.colors.slate};
  /*  inverted back to up-right since the Slider component is inverted */
  transform: scale(-1);

  > div > div {
    background: ${theme.colors.white} !important;
    background-color: ${theme.colors.white};
    padding: 6px 10px;
    border-radius: 4px;
    top: 6px;

    > div {
      text-align: center;
    }

    ${(props) => {
      if (props.length > 3) {
        if (props.shiftLeft) {
          return `margin-left: calc(-6 * ${props.length}px);`
        } else {
          return `margin-left: calc(6 * ${props.length}px);`
        }
      }
      return
    }}

    &::after {
      border-top-color: ${theme.colors.white};
      ${(props) => {
        if (props.length > 3) {
          if (props.shiftLeft) {
            return `margin-right: calc(-6 * ${props.length}px);`
          } else {
            return `margin-right: calc(6 * ${props.length}px);`
          }
        }
        return ''
      }}
    }
  }
`

export const AgeOfTransferLabel = styled.div`
  ${fonts.AN_10_500_13}
  color: ${theme.colors.stone};
  white-space: nowrap;
`
